export const ACTIVITY_TABS = {
	TEXTS: "Texts",
	EMAILS: "Emails",
};

export const ACTIVITY_TABLE_COLUMNS = [
	{ id: "ActivityDate", isSortable: true, label: "Activity Date"},
	{ id: "DPD", isSortable: false, label: "DPD"},
	{ id: "CustomersContacted", isSortable: true, label: "Customers Contacted"},
	{ id: "Payments", isSortable: true, label: "Payments"},
	{ id: "Promises", isSortable: true, label: "Promises"},
	{ id: "PaymentAmount", isSortable: true, label: "Payment Amount"},
	{ id: "PromiseAmount", isSortable: true, label: "Promise Amount"},
	{ id: "TotalAmount", isSortable: true, label: "Total Amount"},
];

export const formatDateTime = (value) => {
    if (!value) return null;
    if (value instanceof Date && !isNaN(value)) {
        const pad = (n, z = 2) => String(n).padStart(z, "0");
        return (
            value.getFullYear() + "-" +
            pad(value.getMonth() + 1) + "-" +
            pad(value.getDate()) + " " +
            pad(value.getHours()) + ":" +
            pad(value.getMinutes()) + ":" +
            pad(value.getSeconds()) + "." +
            pad(value.getMilliseconds(), 3)
        );
    }
    if (typeof value === "string") {
        return value.replace("T", " ").replace("Z", "");
    }
    return null;
};